import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { Icon } from '@/components/icon'
import { Button } from '@/components/ui'
import type { TEmpreendimentoBase } from '@/features/empreendimentos/shared/types/empreendimento'
import type { IBreadcrumbItem } from '@/layouts/page'

type TSecaoAcoesEmpreendimentoProps = {
  idExterno: number
  breadcrumb: IBreadcrumbItem[]
  tipo: TEmpreendimentoBase['tipo']
}

export const SecaoAcoesEmpreendimento = ({ idExterno, breadcrumb, tipo }: TSecaoAcoesEmpreendimentoProps) => {
  const { t } = useTranslation('empreendimentos')
  const navigate = useNavigate()

  const breadcrumbDetalhesEmpreendimento = breadcrumb.map((item) => {
    if (item.to) return item
    return { label: item.label, to: `/es-CL/empreendimentos/${idExterno}` }
  })

  const handleConsultarUnidades = () => {
    const urlEspelhoVendas =
      tipo === 'Horizontal'
        ? `/es-CL/espelho-de-vendas/horizontal/${idExterno}`
        : `/es-CL/espelho-de-vendas/${idExterno}`
    navigate(urlEspelhoVendas, {
      state: {
        breadcrumbDetalhesEmpreendimento,
      },
    })
  }

  return (
    <div className="shadow-cz flex h-20.5 items-center justify-between rounded-sm p-4">
      <div className="grid gap-1">
        <div className="flex w-full items-center gap-2">
          <Icon className="text-sky-700" name="hotel" size={24} />
          <h4 className="text-sky-900">{t('pages.detalhes.secoes.acoes.unidades.titulo')}</h4>
        </div>
        <p className="pl-7 text-sm text-neutral-600">{t('pages.detalhes.secoes.acoes.unidades.descricao')}</p>
      </div>
      <Button className="w-42" onClick={handleConsultarUnidades}>
        {t('pages.detalhes.secoes.acoes.unidades.botao')}
      </Button>
    </div>
  )
}
